const e = "adyen-pe-base-button";
export {
  e as DEFAULT_BASE_BUTTON_CLASSNAME
};
